import { Component } from 'react';

class Empty extends Component {
  render() {
    return null;
  }
}

export default Empty;
